// Testi verificati sulla dashboard il 2026-10-16 (vedi spec guide richieste, note spese e report).
export default {
  slug: 'richieste',
  module: 'requests',
  title: 'Le richieste',
  tile: 'Approva ferie e permessi, gestisci gli annullamenti, inserisci una richiesta.',
  minutes: 4,
  publishedAt: '2026-10-26T12:00:00.000Z',
  moduleLabel: 'Apri le richieste',
  modulePath: 'requests',
  brief: {
    purpose: 'Gestire ferie, permessi e altre assenze chieste dai dipendenti.',
    who: 'Chi in azienda approva le richieste.',
    when: 'Ogni volta che arriva una richiesta da approvare.',
  },
  steps: [
    {
      title: 'Le schede',
      text: '«Da approvare» è la vista di partenza; nelle altre schede trovi Tutte, Approvate, Rifiutate, In annullamento e Annullate.',
      screen: 'richieste-1',
      notes: ['«Da approvare»: le richieste che aspettano una tua risposta', 'Il numero accanto a ogni scheda dice quante sono'],
    },
    {
      title: 'Approva o rifiuta',
      text: 'Clicca una riga: in «Dettagli richiesta» premi «Approva» o «Rifiuta». Se modifichi le date o la tipologia, il pulsante diventa «Approva con modifiche».',
      screen: 'richieste-2',
      notes: ['Controlla dipendente, tipologia e date', '«Approva» conferma, «Rifiuta» respinge la richiesta'],
      tip: 'Nella scheda «Da approvare» puoi selezionare più richieste e premere «Approva (N)».',
    },
    {
      title: 'Le richieste di annullamento',
      text: 'Quando un dipendente chiede di annullare una richiesta approvata, la trovi in «In annullamento»: apri la riga e scegli «Conferma annullamento» o «Rifiuta annullamento».',
      screen: 'richieste-3',
      notes: ['«In annullamento»: richieste approvate che il dipendente vuole annullare', 'Conferma o rifiuta l’annullamento'],
    },
    {
      title: 'Inserisci una richiesta per un dipendente',
      text: 'Premi «Aggiungi richiesta», scegli dipendente e tipologia, «Un giorno» o «Più giorni», e premi «Salva richiesta».',
      screen: 'richieste-4',
      notes: ['Scegli il dipendente e la tipologia', '«Un giorno» o «Più giorni», poi le date'],
    },
  ],
  faq: [
    {
      question: 'Posso modificare una richiesta già approvata?',
      answer: 'Sì: aprila, cambia ciò che serve e premi «Applica modifiche», oppure «Annulla» per annullarla.',
    },
    {
      question: 'Non vedo «Approva» o «Aggiungi richiesta»',
      answer: "Serve il permesso di approvare le richieste. Chiedilo a chi amministra l'account HeyJob della tua azienda.",
    },
  ],
};
